import React from 'react';
import { Toast } from 'react-bootstrap';

// Shown when the media health monitor calls the path lossy: the connection is
// up, packets arrive, but nearly all video packets are lost before they reach
// this browser. The retry starts a fresh session that prefers TURN over TCP —
// a different route through the network — which is the one remedy a viewer
// can apply on their side. Manual for now: the monitor only measures until its
// false-positive rate is known.
const MediaHealthToast = ({ show, onRetry, onClose }) => {
  return (
    <Toast
      show={show}
      onClose={onClose}
      style={{
        position: 'fixed',
        left: 20,
        right: 'auto',
        bottom: 20,
        zIndex: 9999,
        width: 'calc(100vw - 40px)',
        maxWidth: 380,
        background: 'rgba(46, 32, 12, 0.92)',
        color: '#fff',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: '1px solid rgba(255, 180, 70, 0.45)',
        borderRadius: 8,
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.35)',
        fontSize: 12,
      }}
    >
      <Toast.Body style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '12px 14px' }}>
        <div style={{ flex: 1, minWidth: 0, lineHeight: 1.45 }}>
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, color: '#ffb84d' }}>
            Video is not getting through
          </div>
          <div style={{ color: 'rgba(255,255,255,0.9)', marginBottom: 8 }}>
            Your network is dropping most of the stream on its way to you. Retrying over a different route usually fixes this.
          </div>
          <button
            type="button"
            onClick={onRetry}
            style={{
              background: '#ffb84d',
              color: '#2e200c',
              border: 'none',
              borderRadius: 6,
              padding: '6px 12px',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Retry over TCP
          </button>
        </div>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'rgba(255,255,255,0.7)',
            cursor: 'pointer',
            fontSize: 18,
            lineHeight: 1,
            padding: '4px 6px',
            margin: '-4px -6px -4px 0',
            flexShrink: 0,
          }}
        >
          ×
        </button>
      </Toast.Body>
    </Toast>
  );
};

export default MediaHealthToast;
